import React from 'react';

const steps = [
    {
        num: '01',
        title: 'Place Your Order',
        desc: 'Submit your order or delivery request online, by phone, or through your account manager. Tell us what you need and when.'
    },
    {
        num: '02',
        title: 'We Pick It Up',
        desc: 'Our driver arrives at your location within the agreed time window. We handle packaging verification and receipt.'
    },
    {
        num: '03',
        title: 'Track in Real Time',
        desc: 'Follow your shipment live on our platform. Automated updates keep you and your recipient informed every step.'
    },
    {
        num: '04',
        title: 'Delivered & Confirmed',
        desc: 'Proof of delivery with signature or photo confirmation. Full audit trail for every shipment, every time.'
    },
];

const regions = [
    {name: 'Akkar', selected: true},
    {name: 'Aley', selected: true},
    {name: 'Baabda', selected: true},
    {name: 'Baalbek', selected: true},
    {name: 'Batroun', selected: true},
    {name: 'Beirut', selected: true},
    {name: 'Bint Jbeil', selected: false},
    {name: 'Bsharri', selected: true},
    {name: 'Chouf', selected: true},
    {name: 'Hasbaya', selected: false},
    {name: 'Hermel', selected: false},
    {name: 'Jbeil', selected: true},
    {name: 'Jezzine', selected: true},
    {name: 'Keserwan', selected: true},
    {name: 'Koura', selected: true},
    {name: 'Marjeyoun', selected: false},
    {name: 'Matn', selected: true},
    {name: 'Miniyeh', selected: true},
    {name: 'Nabatieh', selected: true},
    {name: 'Rashaya', selected: false},
    {name: 'Sidon', selected: true},
    {name: 'Tripoli', selected: true},
    {name: 'Tyre', selected: true},
    {name: 'West Beqaa', selected: true},
    {name: 'Zahle', selected: true},
    {name: 'Zgharta', selected: true},
];

export default function Coverage() {
    return (
        <section id="coverage" className="bg-[#f8f8f6] lg-custom:py-20 py-12">
            <div className="dh-container">

                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '150px', alignItems: 'center'}} className="cov-grid">
                    <div>
                        <div style={{textAlign: 'left'}}>
                            <div className="uppercase" style={{
                                display: 'inline-block', background: '#fefce8', color: '#a38900',
                                borderRadius: '100px', padding: '3px 14px', fontSize: '12px',
                                fontFamily: "'Inter'", fontWeight: 500, marginBottom: '13px', letterSpacing: '0.5px',
                            }}>
                                coverage & process
                            </div>
                            <h2 style={{
                                fontFamily: "'Bebas Neue'",
                                fontWeight: 900,
                                fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                                lineHeight: '0.95',
                                marginBottom: '1.5rem',
                            }}>
                                every<br/>district.<br/>one hub.
                            </h2>
                            <div className="text-neutral-500 text-base" style={{
                                fontFamily: "'Inter'",
                                lineHeight: 1.65,
                                textAlign: 'justify',
                                maxWidth: '32rem',
                            }}>
                                Delivering across most Lebanese governorates and districts - extending our reach where others stop.
                            </div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '0'}}>
                            {steps.map((step, i) => (
                                <div key={step.num} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1.5rem',
                                    padding: '1.25rem 0',
                                    borderBottom: '1px solid rgba(0,0,0,0.08)',
                                    transition: 'all 0.2s'
                                }}
                                     onMouseEnter={e => e.currentTarget.querySelector('.step-num').style.color = '#0a4abe'}
                                     onMouseLeave={e => e.currentTarget.querySelector('.step-num').style.color = 'inherit'}
                                >
                                    <div className="step-num" style={{
                                        fontFamily: "'Bebas Neue'",
                                        fontSize: '3.5rem',
                                        lineHeight: '1',
                                        minWidth: '60px',
                                        transition: 'color 0.2s'
                                    }}>
                                        {step.num}
                                    </div>
                                    <div style={{paddingTop: '10px'}}>
                                        <h3 style={{
                                            fontFamily: "'Inter'",
                                            fontWeight: 700,
                                            fontSize: '17px',
                                            marginBottom: '6px',
                                            color: '#0d0d0d'
                                        }}>{step.title}</h3>
                                        <p style={{
                                            fontFamily: "'Inter'",
                                            color: '#5c5c56',
                                            fontSize: '14px',
                                            lineHeight: 1.65
                                        }}>{step.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={'bg-dh-blue rounded-md lg-custom:p-10 p-6'}>
                        <div className="grid grid-cols-3 gap-2.5">
                            {regions.map(r => (
                                <div key={r.name} className={`py-2 rounded-sm border transition-transform duration-150 cursor-pointer hover:scale-105 hover:-translate-y-0.5 ${
                                    r.selected
                                        ? 'bg-dh-yellow-15 border-dh-yellow/80 font-medium text-dh-yellow rounded-sm'
                                        : 'bg-neutral-300/20 border-neutral-300/50 text-neutral-300/60'
                                }`}>
                                    <div className={'text-center text-sm'} style={{
                                        fontFamily: "'Inter'",
                                    }}>{r.name}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/*<section id="coverage"*/}
            {/*         style={{padding: '100px 0', background: '#ffffff', position: 'relative', overflow: 'hidden'}}>*/}
            {/* Background dots */}
            {/*<div style={{*/}
            {/*    position: 'absolute', inset: 0, opacity: 0.05,*/}
            {/*    backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',*/}
            {/*    backgroundSize: '28px 28px',*/}
            {/*}}/>*/}

            <div style={{position: 'relative', zIndex: 1}}>

            </div>

            <style>{`
        @media (max-width: 768px) {
          .cov-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
      `}</style>
        </section>
    );
}